import React from 'react';
import { BarChart3 } from 'lucide-react';

/**
 * Composant réutilisable pour afficher un message informatif quand il n'y a pas de données
 * Utilisé dans les dashboards Facebook Ads, Microsoft Ads, Google Ads, etc.
 */
const NoDataMessage = ({
  title = "Aucune donnée disponible",
  subtitle = "Aucune donnée n'a été trouvée pour le compte sélectionné sur la période choisie.",
  icon = null,
  style = {}
}) => {
  const defaultStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '200px',
    backgroundColor: '#FAF9F5',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    color: '#6b7280',
    fontSize: '16px',
    margin: '40px 0',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    ...style
  };

  return (
    <div className="no-data-placeholder" style={defaultStyle}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
          {icon || <BarChart3 size={48} color="#9ca3af" />}
        </div>
        <div style={{ fontWeight: '600', fontSize: '22px', marginBottom: '12px', color: '#374151' }}>
          {title}
        </div>
        <div style={{ fontSize: '16px', color: '#6b7280', lineHeight: '1.5' }}>
          {subtitle}
        </div>
      </div>
    </div>
  );
};

export default NoDataMessage;